import {memoize} from 'lodash';
import formatValue from './formatValueViaRemoteHttp';

export default memoize(function formatNumber(value: number): Promise<string> {
    return formatValue('/rcm-number-format-http-api/number/', value);
});
